module.exports = __webpack_public_path__ + "img/LeConte_Hall_-_DP_-_t-24543-077.44385094.jpg";